import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {ForgotPasswordComponent} from './forgot-password.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.forgotPassword.pageInRouting,
    data: {data: PAGES_AND_PATHS.forgotPassword},
    component: ForgotPasswordComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./forgot-password.module').then(m => m.ForgotPasswordModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForgotPasswordRoutingModule { }
